import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import protoRoot from './proto';
/** 解析trpc response header */

export var parseHeaders = function parseHeaders(headers) {
  var callType = headers['trpc-call-type']; // 中文会乱码

  var errorMsg = decodeURIComponent(escape(headers['trpc-error-msg']));
  var funcRet = parseInt(headers['trpc-func-ret']);
  var messageType = headers['trpc-message-type'];
  var requestId = headers['trpc-request-id'];
  var ret = parseInt(headers['trpc-ret']);
  var version = headers['trpc-version'];
  return {
    callType: callType,
    errorMsg: errorMsg,
    funcRet: funcRet,
    messageType: messageType,
    requestId: requestId,
    ret: ret,
    version: version
  };
};
/**
 * 处理返回码 抛出异常
 * @param originHeaders
 */

var transformHeader = function transformHeader(originHeaders) {
  var headers = parseHeaders(originHeaders);

  if (headers.ret === 0 && headers.funcRet === 0) {
    return true;
  } else {
    var ret = headers.ret !== 0 ? headers.ret : headers.funcRet;
    var error = new Error("request failed: ".concat(headers.errorMsg, " (").concat(ret, ")"));
    error.ret = ret;
    error.msg = headers.errorMsg;
    error.requestId = headers.requestId;
    throw error;
  }
};
/** 普通转化json */


export var transformResponse = function transformResponse(rawResponse, headers) {
  transformHeader(headers);

  try {
    var res = JSON.parse(rawResponse);
    return res;
  } catch (err) {
    console.error(err);
    throw new Error('request failed: Json parse error');
  }
};
/** 根据proto文件解析json, 处理int64 string -> number */

export var transformJsonResponseFactory = function transformJsonResponseFactory(responseType) {
  return function transformResponse(rawResponse, headers) {
    transformHeader(headers);

    try {
      var res = JSON.parse(rawResponse);
      var PBMessageResponse = protoRoot.lookup(responseType);
      var json = PBMessageResponse.decode(PBMessageResponse.encode(res).finish());
      return json;
    } catch (err) {
      console.error(err);
      throw new Error('request failed: Json parse error');
    }
  };
};
/** 解析二进制 */

export var transformProtoResponseFactory = function transformProtoResponseFactory(responseType) {
  return function transformResponse(rawResponse, headers) {
    transformHeader(headers);

    try {
      var PBMessageResponse = protoRoot.lookup(responseType);
      var json = PBMessageResponse.decode(new Uint8Array(rawResponse));
      return json;
    } catch (err) {
      console.error(err);
      throw new Error('request failed: Json parse error');
    }
  };
};